import { useQuery } from '@tanstack/react-query'
import { apiCall } from '@/api/client'
import type { MapFile } from '@/types'

interface MapFilesResponse {
  site_id: string
  robot_id: string
  files: MapFile[]
}

async function fetchMapFiles(
  siteId: string,
  robotId: string
): Promise<MapFilesResponse> {
  const resp = await apiCall(
    'GET',
    `/api/map-storage/sites/${siteId}/${robotId}/files`
  )
  if (!resp.ok) {
    throw new Error(`Failed to fetch files: ${resp.status}`)
  }
  return resp.json()
}

export function useMapFiles(siteId: string | null, robotId: string | null) {
  return useQuery({
    queryKey: ['mapFiles', siteId, robotId],
    queryFn: () => fetchMapFiles(siteId!, robotId!),
    enabled: !!siteId && !!robotId,
  })
}

export async function deleteMapFile(
  siteId: string,
  robotId: string,
  filename: string
): Promise<void> {
  const resp = await apiCall(
    'DELETE',
    `/api/map-storage/sites/${siteId}/${robotId}/files/${filename}`
  )
  if (!resp.ok) {
    throw new Error(`Failed to delete file: ${resp.status}`)
  }
}

export async function downloadMapFile(
  siteId: string,
  robotId: string,
  filename: string
): Promise<string> {
  const resp = await apiCall(
    'GET',
    `/api/map-storage/sites/${siteId}/${robotId}/files/${filename}/download`
  )
  if (!resp.ok) {
    throw new Error(`Failed to get download URL: ${resp.status}`)
  }
  const data = await resp.json()
  return data.url
}
